import { provideSingleton } from '@v2/utilities/di/provide-singleton';
import { filterIsTruthy } from '@v2/utilities/pure-utils/filter-is-truthy';
import { distinctUntilChanged, filter, map, Observable, of, ReplaySubject, switchMap, take } from 'rxjs';
import { CpUserInfo } from '../api-access/cp-api/models/cp-user-info';
import { CpUserInfoDetails } from '../api-access/cp-api/models/cp-user-info-details';

export class CpUserDataInfo {
  public userInfo$: ReplaySubject<CpUserInfo | undefined> = new ReplaySubject<CpUserInfo | undefined>(1);
  public userInfoDetails$: ReplaySubject<CpUserInfoDetails | undefined> = new ReplaySubject<
    CpUserInfoDetails | undefined
  >(1);
  /*public walletInfoMisc$: BehaviorSubject<CpWalletInfoMisc | undefined> = new BehaviorSubject<
    CpWalletInfoMisc | undefined
  >(undefined);
  public userBalance$: ReplaySubject<CpUserBalance | undefined> = new ReplaySubject<CpUserBalance | undefined>(1);*/

  public getCountry = (): Observable<string> => {
    return this.userInfo$.pipe(
      filter((userInfo: CpUserInfo | undefined) => userInfo !== undefined),
      map((userInfo: CpUserInfo) => userInfo.countryCode ?? userInfo.countryIp),
      filterIsTruthy(),
      distinctUntilChanged()
    );
  };

  public isLoggedIn = (): Observable<boolean> => {
    return this.userInfo$.pipe(
      filter((userInfo: CpUserInfo | undefined) => userInfo !== undefined),
      map((userInfo: CpUserInfo) => userInfo.status === 'logged'),
      distinctUntilChanged()
    );
  };

  public getUserInfoDetails(): Observable<CpUserInfoDetails | undefined> {
    return this.isLoggedIn().pipe(
      switchMap((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          return of(undefined);
        }
        return this.userInfoDetails$.pipe(filterIsTruthy(), take(1));
      })
    );
  }

  /*public getWalletId(): Observable<string | undefined> {
    return this.isLoggedIn().pipe(
      switchMap((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          return of(undefined);
        }
        return this.userInfoDetails$.pipe(
          filterIsTruthy(),
          map((details: CpUserInfoDetails) => details.walletId),
          take(1)
        );
      })
    );
  }*/
}
export function provideCpUserDataInfo(): CpUserDataInfo {
  return provideSingleton(CpUserDataInfo, () => new CpUserDataInfo());
}
